

    <template>
    <div id='sales-order'>
        <template v-if="showPage == 0">
            <el-card class='search-input-wrap table_searchbar'>
                <div class='search-input-wrap table_searchbar'>
                    <!-- <el-row class='search-input-row' style="margin-bottom: 20px;margin-top: 0px;">
                        <div style="display:flex" class="warp-box">
                            <div :class="activeItem==null?['active-item','status-item']:['status-item']" @click="changeActive()">
                                <span>全部</span>
                            </div>
                            <div class="status-warp">
                                <div class="line"></div>
                                <div :class="activeItem==5?['active-item1','status-item','warp-item1']:['status-item',,'warp-item1']" @click="changeActive(5)">
                                    <span>未排产({{statusCount5}})</span>
                                </div>
                                <div :class="activeItem==7?['active-item2','status-item','warp-item1']:['status-item',,'warp-item2']" @click="changeActive(7)">
                                    <span>部分排产({{statusCount7}})</span>
                                </div>
                                <div :class="activeItem==4?['active-item2','status-item','warp-item2']:['status-item',,'warp-item2']" @click="changeActive(4)">
                                    <span>已排产({{statusCount4}})</span>
                                </div>
                                <div :class="activeItem==0?['active-item2','status-item','warp-item2']:['status-item',,'warp-item2']" @click="changeActive(0)">
                                    <span>生产中({{statusCount0}})</span>
                                </div>
                                <div :class="activeItem==2?['active-item2','status-item','warp-item2']:['status-item',,'warp-item2']" @click="changeActive(2)">
                                    <span>部分完成({{statusCount2}})</span>
                                </div>
                                <div :class="activeItem==1?['active-item3','status-item','warp-item3']:['status-item',,'warp-item3']" @click="changeActive(1)">
                                    <span>已完成</span>
                                </div>
                            </div>
                            <div :class="activeItem==6?['active-item','status-item']:['status-item']" @click="changeActive(6)">
                                <span>已取消</span>
                            </div>
                            <div :class="activeItem==99?['active-item','status-item']:['status-item']" @click="changeActive(99)">
                                <span>已延期({{statusCount99}})</span>
                            </div>
                            <div style="margin-right:0px" :class="activeItem==3?['active-item','status-item']:['status-item']" @click="changeActive(3)">
                                <span>已关闭</span>
                            </div>
                        </div>
                    </el-row> -->

                    <el-row class='search-input-row'>
                        <el-col :span='5'>
                            <div>
                                <span class="title">订单号：</span>
                                <el-select style="width:230px" filterable="filterable" clearable="clearable" allow-create :loading="orderLoading" :remote-method="remoteMethod5" remote="remote" @visible-change='closeOrderList' v-model='searchForm.orderId' size='small' maxlength='16' placeholder='订单号'
                                    @change='orderSelectChange' @keyup.enter.native='search' popper-class='width180'>
                                    <el-tooltip placement="right" v-for="item in orderOptions" :key="item.id" :content="item.label" :disabled="(span==5?item.label.length<=17:item.label.length<=17)">
                                        <el-option :value="item.label" :label="item.label"></el-option>
                                    </el-tooltip>
                                    <div v-if="orderOptions.length > 48" class="search-keyword" style="text-align:center">
                                        <span style="font-size:12px;color:red">只显示前50条结果，请完善搜索关键字</span>
                                    </div>
                                </el-select>
                            </div>
                        </el-col>

                        <el-col :span='5'>
                            <div>
                                <span class="title" style="margin-left: -34px;width: 106px;">物料编码：</span>
                                <el-select clearable :remote-method="query=>this.remoteMethod4(query,'',0)" @visible-change='closeProductList($event,0)' :loading="productLoading" remote="remote"
                                    filterable="filterable" @change='codeSelectChange($event)' style="width:230px" v-model="searchForm.materialCode" placeholder='物料编码'>
                                    <el-option v-for="item in materialList1" :key="item.materialCode" :value="item.materialCode" :label="item.materialCode"></el-option>
                                </el-select>
                            </div>
                        </el-col>

                        <el-col :span="5">
                            <div>
                                <span class="title" style="margin-left: -34px;width: 106px;">物料名称：</span>
                                <el-select clearable :remote-method="query=>this.remoteMethod4('',query,1)" @visible-change='closeProductList($event,0)' :loading="productLoading" remote="remote"
                                    filterable="filterable" @change='codeSelectChange($event)' style="width:230px" v-model="searchForm.materialName" placeholder='物料名称'>
                                    <el-option v-for="item in materialList" :key="item.id" :value="item.materialName" :label="item.materialName"></el-option>
                                </el-select>
                            </div>
                        </el-col>

                        <el-col :span='5' >
                            <div>
                                <span class="title">下单日期：</span>
                                <el-date-picker style="width:230px" v-model="searchForm.orderTime" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd"   ></el-date-picker>
                            </div>
                        </el-col>
                        <el-col :span='4'>
                            <div style="text-align:right">
                                <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
                                    {{ showMore ? '收起' : '展开' }}
                                    <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                                </a>
                                <el-button size='mini' type='primary' icon="el-icon-search" @click='clickSearch'>查询
                                </el-button>
                                <el-button size='mini' icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                            </div>
                        </el-col>

                    </el-row>
                <el-collapse-transition>
                    <div v-show="showMore">
                        <el-row style="margin-top:10px" >
                            <el-col :span='span' >
                                <div>
                                    <span class="title">交货日期：</span>
                                    <el-date-picker style="width:230px" v-model="searchForm.deliverTime" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd"   ></el-date-picker>
                                </div>
                            </el-col>
                            <el-col :span='5'>
                                <div>
                                    <span class="title" style="margin-left: -34px;width: 106px;">订单状态：</span>
                                    <el-select style="width:230px" clearable placeholder='订单状态' v-model="searchForm.businessState">
                                        <el-option label="未制单" :value="1"></el-option>
                                        <el-option label="部分制单" :value="2"></el-option>
                                        <el-option label="已制单" :value="3"></el-option>
                                        <el-option label="已关闭" :value="4"></el-option>
                                    </el-select>
                                </div>
                            </el-col>

                            
                        </el-row>
                    </div>
                </el-collapse-transition>
                </div>
            </el-card>
            <el-card class="table-card">
                <el-row class='operateBtn-wrap' style="margin-bottom:10px">
                    <el-col :span='12'>
                        <el-button type='primary' icon="el-icon-plus" :size='buttonSize' v-if="permission.btn_order_addOrder" @click='addOrder'>新增订单</el-button>
                        <!-- <el-button type='primary' icon="el-icon-upload el-icon--left" :size='buttonSize' v-if="permission.btn_order_importOrder2" @click='importOrder'>导入订单</el-button>
                        <a href="/api/order/sampleDownload" v-if="permission.btn_order_sampleDownload">
                            <el-button :size='buttonSize'>模板下载<i class="el-icon-download el-icon--right"></i></el-button>
                        </a> -->
                        <!-- <span class="planed-ratio" style="margin-left: 10px;">
                            上周排单率：<span :style="plannedRatio<50?{color:'red'}:{}">{{plannedRatio}}%</span>
                        </span>
                        <el-popover placement='top' width="300" trigger="hover">
                            <div>上周排单率：上周可排产订单中已经排产的比例</div>
                            <div>
                                <span class="show-icon" style="background: url(../../../static/img/problem.png)"></span>：代表物料待检入库
                            </div>
                            <div>
                                <span class="show-icon" style="background: url(../../../static/img/success.png)"></span>：代表物料已入库
                            </div>
                            <span slot="reference" class="help"></span>
                        </el-popover> -->
                        <!-- <el-checkbox v-if="activeItem!=2" v-model="checked" ref="Checkbox" style="margin-left: 10px" @change="rowDataIs($event)">显示延期订单</el-checkbox> -->
                        <el-checkbox v-model="showOrderRow" style="margin-left: 10px" @change="showAllRow($event)">显示工单
                        </el-checkbox>
                    </el-col>

                    <!-- <el-col :span='12' style="text-align:right;">
                        <el-button v-if="permission.btn_order_doMRP" type='primary' :size='buttonSize' @click='selectSalesOrder'>生产制单</el-button>
                    </el-col> -->
                </el-row>
                <el-row class='tab'>
                    <el-row class='table-wrap'>
                        <el-table :data='tableData' ref="refTable" @row-click="expandChange" tooltip-effect='dark' :default-sort='defaultSort' @sort-change='sortChangeEvent' :header-cell-class-name='handlemyclass' :row-style="rowClass" :row-key="getRowKeys" :expand-row-keys="expands" border>
                            <!-- <el-table-column type="selection" :selectable='selectable' width="55"></el-table-column> -->
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <el-card  class="table-in-table" style="width:92%;margin-left:4%;margin-right:4%;">
                                    <el-table :data="props.row.itemList" row-key="id" border>
                                        <el-table-column prop="index" label="订单行" width="70">
                                            <template slot-scope="scope">
                                                {{scope.$index+1}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="materialCode" label="物料编码" min-width="80" show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="materialName" label="物料名称" min-width="80" show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="specification" label="规格型号" min-width="80" show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="itemState" label="物料状态" min-width="80" :formatter='parseMaterialState' show-overflow-tooltip>

                                        </el-table-column>
                                          <el-table-column prop='preparedUserName' label='制单人' min-width='60' max-width="100" show-overflow-tooltip="show-overflow-tooltip"></el-table-column>
                                        <!-- <el-table-column prop="consumption" label="消耗率" min-width="60" show-overflow-tooltip></el-table-column> -->
                                        <el-table-column :v-if="props.row.optional.length>0" min-width="60" v-for="item in props.row.optional" :label="item" :key="item" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span>{{scope.row.optional|showAttrValue(item)}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="unitType" label="单位" min-width="50" show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="itemCount" label="数量" min-width="50" show-overflow-tooltip></el-table-column>
                                        <el-table-column label="" min-width="100" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <el-button v-if="scope.row.itemState == 1" type='primary' :size='buttonSize' @click='prepareDocument(scope.row)'>制单</el-button>
                                                <el-button v-if="(scope.row.itemState == 2||scope.row.itemState == 3)&&permission.btn_order_listBilledDetail" type='primary' :size='buttonSize' @click='showPrepareDetail(scope.row)'>制单详情</el-button>
                                                <el-button v-if="scope.row.itemState == 2&&permission.btn_order_cancelMrp" type='primary' :size='buttonSize' @click='cancelMrp(scope.row)'>取消制单</el-button>
                                            </template>
                                        </el-table-column>
                                        <!-- <el-table-column prop="" label="备注" min-width="60" show-overflow-tooltip></el-table-column> -->
                                    </el-table>
                                    </el-card>
                                </template>
                            </el-table-column>

                            <el-table-column prop='orderCode' class-name='paddingtop' label='订单号' min-width='80' max-width="160" show-overflow-tooltip="show-overflow-tooltip">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.orderMaterialState!=null" class="show-icon" :style="scope.row.orderMaterialState==1?{background: 'url(/static/img/success.png)'}:{background: 'url(../../../../static/img/problem.png)'}"></span>
                                    {{scope.row.orderCode}}
                                    <img v-if="scope.row.isUrgent" style="width: 12px;height: 12px;margin-right: 2px;" src="/static/img/jiaji.png" alt="">
                                </template>
                            </el-table-column>

                            <el-table-column prop='orderTime' label='签订日期' min-width='80' max-width="160" sortable="custom" show-overflow-tooltip="show-overflow-tooltip"></el-table-column>
                            <el-table-column prop='deliverTime' label='交货日期' min-width='80' max-width="160" align="center" sortable="custom" show-overflow-tooltip="show-overflow-tooltip">
                                <template slot-scope="scope">
                                    <div :class="deliverClass(scope.row.isPostpone)">
                                        <span>{{scope.row.deliverTime}}</span>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column prop='businessState' class-name='paddingtop' :formatter='parseOrderState' label='订单状态' min-width='80' align="center" show-overflow-tooltip="show-overflow-tooltip">
                                <template slot-scope="scope">
                                    <span :style="{color:parseStyle(scope.row)}">{{parseOrderState(scope.row)}}</span>
                                </template>
                            </el-table-column>

                            <!-- <el-table-column prop='processRatio' class-name='paddingtop' sortable="custom" label='订单进度' min-width='80' max-width="170" show-overflow-tooltip="show-overflow-tooltip">
                                <template slot-scope="scope">
                                    <el-progress :class="scope.row.class" :text-inside="true" :stroke-width="18" :color="scope.row.color" :percentage="scope.row.processRatio"></el-progress>
                                </template>
                            </el-table-column> -->
                            <!-- <el-table-column prop='preparedByUserName' label='制单人' min-width='60' max-width="100" show-overflow-tooltip="show-overflow-tooltip"></el-table-column> -->
                            <el-table-column prop='gmtCreate' label='创建时间' min-width='100' max-width="180" sortable="custom" :formatter='$commonUtil.changeToDate' show-overflow-tooltip="show-overflow-tooltip">
                            </el-table-column>
                            <el-table-column prop='gmtModified' label='更新时间' min-width='100' max-width="180" sortable="custom" :formatter='$commonUtil.changeToDate' show-overflow-tooltip="show-overflow-tooltip"></el-table-column>
                            <el-table-column label="操作" class-name='paddingtop' fixed="right" width="280" align="left">
                                <template slot-scope="scope">
                                    <el-button @click.stop="editOrder(scope.row)" v-if="scope.row.businessState!=4&&permission.btn_order_updateOrder" type="text" size="small">编辑</el-button>
                                    <el-button @click.stop="showOrder(scope.row)" v-if="[2,3].includes(scope.row.businessState)" type="text" size="small">查看</el-button>
                                    <el-button @click.stop="deleteOrder(scope.row)" type="text" size="small" v-if="(scope.row.businessState==1&&permission.btn_order_delete_order_by_id)">删除</el-button>
                                    <!-- <el-button @click="cancelOrder(scope.row)" type="text" size="small" v-if="scope.row.canMrp&&permission.btn_order_cancelOrder">取消</el-button> -->
                                    <el-button @click.stop="setUrgentOrder(scope.row)" type="text" size="small" v-if="permission.btn_order_urgent&&!scope.row.isUrgent&&scope.row.canSetUrgency">
                                        设为急单</el-button>
                                    <el-button @click.stop="cancelUrgentOrder(scope.row)" type="text" size="small" v-if="permission.btn_order_urgent&&scope.row.isUrgent&&scope.row.canSetUrgency">取消急单
                                    </el-button>
                                    <el-button @click.stop="closeOrder(scope.row)" type="text" size="small" v-if="permission.btn_order_closeOrder">关闭订单</el-button>
                                    <!-- <el-button @click="cancelMrp(scope.row)" type="text" size="small" v-if="(scope.row.businessState==2||scope.row.businessState==3)&&permission.btn_order_cancelMrp">取消制单</el-button> -->
                                    <el-button @click.stop="showOrderProductView(scope.row)" v-if='permission.btn_virtual_batchOrderList'  type="text" size="small">查看</el-button>
                                </template>
                            </el-table-column>

                        </el-table>
                    </el-row>
                    <div class="page" v-if="page.isShow">
                        <div class="total_page">
                            <span>共{{page.total}}条{{page.pageSize}}条/页</span>
                        </div>
                        <div style="margin-top:10px;text-align:right; margin-bottom:10px;">
                            <el-pagination background="background" layout="prev, pager, next" :total="page.total" @current-change="pageChange" :current-page.sync="page.currentPage"></el-pagination>
                        </div>
                    </div>
                </el-row>
            </el-card>
        </template>

        <!-- 批量导入提示框开始 -->
        <el-dialog title="导入详情" style="z-index:99999999999" :visible.sync="exportDialogVisible" :width="(span?'25%':'30%')" center="center">
            <div class="exprot_info">
                <el-row :gutter="20">
                    <span>总共导入数据条数：</span>
                    <span>{{exportInfo.total}}条</span>
                </el-row>
                <el-row :gutter="20">
                    <span>导入成功数据条数：</span>
                    <span>{{exportInfo.success}}条</span>
                </el-row>
                <el-row :gutter="20">
                    <span>导入失败数据条数：</span>
                    <span>{{exportInfo.fail}}条</span>
                </el-row>
            </div>
            <span slot="footer" class="el-dialog__footer" style="text-align: center;" center="center">
                <a class="import_upload" v-if="exportInfo.url" :href="exportInfo.url">
                    <el-button type="primary">下载失败数据</el-button>
                </a>
                <el-button type="primary" style="margin-left:10px" @click="()=>{this.exportDialogVisible = false}">确 定
                </el-button>
            </span>
        </el-dialog>
        <!-- 批量导入提示框结束 -->

        <!-- 订单拆解MRP运算 -->
        <el-dialog center title="生产拆解" :visible.sync="isShowDialog" :width="W?'78%':'70%'" :close-on-click-modal="false">
            <el-row class="" style="margin-top:20px">
                <el-table :data='spliteList' tooltip-effect='dark' default-expand-all row-key='bomId' :tree-props="{children: 'next', hasChildren: 'hasChildren'}" :height="spliteList.length>8?460:' '" >
                    <!-- <el-table-column label='序号' min-width='60' prop='materialIndex' show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.$index+1}}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop='contractNumber' label='合同序号' min-width='100' show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop='layer' label='阶层' :formatter="row=>row.layer+1" min-width='100' show-overflow-tooltip>
                    </el-table-column>
                    <!-- <el-table-column prop='orderItemRow' label='订单行' min-width='100' show-overflow-tooltip>
                    </el-table-column> -->
                  
                    <el-table-column prop='materialName' label='物料名称' min-width='100' show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop='materialCode' label='物料编码' min-width='100' show-overflow-tooltip>
                    </el-table-column>
                      <el-table-column prop='mrpType' :formatter="parseMrpType" label='生产类型' min-width='100' show-overflow-tooltip></el-table-column>
                    <el-table-column prop='demandAmount' label='毛需求量' min-width='90' show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop='useAmount' label='净需求量' min-width='110' show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input @change="itemInputChange($event,scope.row)"  :maxlength="50" v-model="scope.row.producingAmount" placeholder="请输入"></el-input>
                            <!-- <span v-else :style="scope.row.useAmount>scope.row.availableAmount?{color:'red'}:{}">{{scope.row.producingAmount}}</span> -->
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop='availableAmount' label='库存可用量' min-width='80' show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column label='抵扣库存' min-width='60' prop='materialIndex' show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.useStock" @change="itemInputChange($event,scope)">
                            </el-checkbox>
                        </template>
                    </el-table-column> -->
                      <el-table-column prop='specification' label='规格' min-width='110' show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column label="材质" min-width="100">
                        <template slot-scope="scope">
                            <el-select :disabled="scope.row.materialQualityNameDisable" v-model="scope.row.materialQualityName" placeholder="请选择" >
                                <el-option v-for="item in textureList" :key="item.name" :label="item.name" :value="item.name"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(item,sIndex) in propertyExtendList" :key="sIndex" :label="item.propertyName" min-width="120">
                        <template slot-scope="scope">
                            <el-input  v-if="item.inputType==0" :maxlength="50" v-model="scope.row.orderSplitPropertyExtendList[`${sIndex}`].propertyValue" placeholder="请输入"></el-input>
                            <el-select v-if="item.inputType==1" filterable v-model="scope.row.orderSplitPropertyExtendList[`${sIndex}`].propertyValue" remote placeholder="请选择" clearable>
                                <el-option v-for="value in item.values" :key="value" :label="value" :value="value"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
            <span slot="footer" class="dialog-footer" style="margin-top:30px; margin-bottom:50px">
                <el-button type="primary" @click="submitSplitMaterial">确 定</el-button>
                <el-button @click="isShowDialog=false">取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog center title="制单详情" :visible.sync="isShowDetail" :width="W?'78%':'70%'" :close-on-click-modal="false">
            <el-row class="" style="margin-top:20px">
                <el-table :data='spliteList' tooltip-effect='dark' default-expand-all row-key='id' :tree-props="{children: 'next', hasChildren: 'hasChildren'}" :height="spliteList.length>8?460:' '" >
                    <el-table-column prop='contractNumber' label='合同序号' min-width='100' show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop='layer' label='阶层' :formatter="row=>row.layer+1" min-width='100' show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop='materialName' label='物料名称' min-width='100' show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop='materialCode' label='物料编码' min-width='100' show-overflow-tooltip>
                    </el-table-column>
                      <el-table-column prop='mrpType' :formatter="parseMrpType" label='生产类型' min-width='100' show-overflow-tooltip></el-table-column>
                    <el-table-column prop='demandAmount' label='毛需求量' min-width='90' show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop='useAmount' label='净需求量' min-width='110' show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span :style="scope.row.useAmount>scope.row.availableAmount?{color:'red'}:{}">{{scope.row.producingAmount}}</span>
                        </template>
                    </el-table-column>
                      <el-table-column prop='specification' label='规格' min-width='110' show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column  prop="materialQualityName" label="材质" min-width="100">
                    </el-table-column>
                    <el-table-column v-for="(item,sIndex) in propertyExtendList" :key="sIndex" :label="item.propertyName" min-width="120">
                        <template slot-scope="scope">
                            {{scope.row.orderSplitPropertyExtendList[`${sIndex}`].propertyValue}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
           
        </el-dialog>
        <!-- 订单拆解MRP运算 -->

        <ImportOrderDialog :isShow.sync="showImportOrderView"></ImportOrderDialog>
        <AddOrderDialog :isShow.sync="showAddOrderView" :propertyExtendList="propertyExtendList"></AddOrderDialog>
        <EditOrderDialog :isView="isView" :rowData.sync="editForm" :isShow.sync="showEditOrderView" :propertyExtendList="propertyExtendList"></EditOrderDialog>

        <template v-if="showPage == 1">
			<OrderProductView :selectedOrder="selectedOrder"></OrderProductView>
		</template>
    </div>
</template>

<script>
import CommonUtils from '@/util/CommonUtils'
import AddOrderDialog from './AddOrderDialog.vue'
import EditOrderDialog from './EditOrderDialog.vue'
import ImportOrderDialog from "../../importOrder/ImportOrderDialog.vue";
import OrderProductView from './OrderProductView.vue';
export default {
    name: 'SalesOrder',
    components: {
        ImportOrderDialog,
        AddOrderDialog,
        EditOrderDialog,
        OrderProductView,
    },
    data() {
        return {
            isView:false,
            showMore:false,
            propertyExtendList:[],
            materialList:[],
             textureList:[],
            materialList1:[],
            getRowKeys(row) {
                return row.id
            },
            showOrderRow: false,
            expands: [],
            spliteList: {},
            productionInfo: {
                dataList: []
            },
            dataList: [],
            isShowDialog: false,
            isShowDetail: false,
            editForm: {},
            searchCopy: {},
            fristLoad: false,
            plannedRatio: 0,
            statusCount0: 0,
            statusCount2: 0,
            statusCount4: 0,
            statusCount5: 0,
            statusCount99: 0,
            statusCount7: 0,
            activeItem: null,
            checked: true,
            rowData: true,
            productionCodeList: [],
            exportInfo: {
                success: 0,
                fail: 0,
                url: null,
                total: 0
            },
            exportDialogVisible: false,
            W: false,
            searchConditionSpan: 24 / 4,
            searchForm: {
                orderId: '',
                orderCode: '',
                orderStatus: '',
                productionOrderCode: null,
                materialCode: '',
                materialName: '',
                extraValue: null,
                orderTime:[],
                deliverTime:[],
                businessState:null,
            },
            isPostpone: null,
            tableData: [],
            orderType: 'DESC', //排序类型
            orderColumn: 'gmtCreate', //排序列
            defaultSort: {
                prop: 'gmtCreate',
                order: 'descending'
            }, //默认排序设置
            page: {
                isShow: false,
                total: 0,
                currentPage: 1,
                pageSize: 10
            },
            buttonSize: 'small', //按钮的大小
            showImportOrderView: false,
            showAddOrderView: false,
            showEditOrderView: false,
            orderLoading: false,
            orderOptions: [],
            deviceLoading: false,
            deviceOptions: [],
            workerLoading: false,
            productLoading: false,
            workerOptions: [],
            showPage: 0,
            Check: true,
            selectedOrder: null,
            comebackFlag: false,
            selectOrderName: '',
            options: [  //0-生产中 1-已完成 2-部分完成 3-已关闭 4-已排产 5-未排产 6-已取消  7-部分排产
                // {
                //     value: '5',
                //     label: '未排产'
                // },
                // {
                //     value: '7',
                //     label: '部分排产'
                // }, {
                //     value: '4',
                //     label: '已排产'
                // }, {
                //     value: '0',
                //     label: '生产中'
                // }, {
                //     value: '2',
                //     label: '部分完成'
                // }, {
                //     value: '1',
                //     label: '已完成'
                // }, {
                //     value: '3',
                //     label: '已关闭'
                // }, {
                //     value: '6',
                //     label: '已取消'
                // }
                {
                    value: 1,
                    label: '未制单',
                },
                {
                    value: 2,
                    label: '部分制单',
                },
                {
                    value: 3,
                    label: '已制单',
                },
                {
                    value: 4,
                    label: '已关闭',
                },
            ],
            materialStateOptions:[
                {
                    value: 1,
                    label: '未制单'
                },
                {
                    value: 2,
                    label: '未生产'
                },
                {
                    value: 3,
                    label: '生产中'
                },
                {
                    value: 4,
                    label: '已完工'
                },
                {
                    value: 5,
                    label: '关闭'
                },
            ],
            searchStr: '',
            permission: JSON.parse(localStorage.getItem("permission"))
        }
    },

    mounted: async function () {
        this.getPropertyExtendList();
        this.search(1)
        this.orderRemoteMethod();
        this.deviceRemoteMethod();
        this.workerRemoteMethod();
        this.loadProductionCode()
        this.loadstatusOrderCount();
        this.loadTextureList()
        let data = await this.loadMaterialList()
        this.materialList = commonUtils.cloneObj(data)
        this.materialList1 = commonUtils.cloneObj(data)
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900
            ? this.W = true
            : this.W = false

        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900
                ? this.W = true
                : this.W = false
        }
    },

    computed: {
        span() {
            return this.W
                ? 5
                : 7
        },
        activeStatus() {
            if (this.$store.state.orderState == 5) {
                if (this.activeItem != 5) {
                    this.changeActive(5)
                }
                this.$store.commit('changeOrderState', null)
            }
            return this.$store.state.orderState
        },
        orderPageChange() {
            if (this.$store.state.orderPage.showPage == 1) {
                this.showPage = 0
                setTimeout(() => {
                    let data = CommonUtils.cloneObj(this.$store.state.orderPage)
                    // console.log(data);
                    this.showOrderProductView(data)
                    // console.log(this.showOrderProductView(data))
                    data.showPage = 0
                    this
                        .$store
                        .commit('changeOrderPage', data)
                }, 0)
            }
            return this.$store.state.orderPage.showPage
        },

    },
    methods: {
        toggleShowMore(){
            this.showMore = ! this.showMore
        },
        async loadTextureList(){
            let {data} = await this.$RequestUtil.getAsync({url: '/api/masterData/material-quality/list',params:{}})
            this.textureList = data
        },
        async getPropertyExtendList(){
            let {code,data} = await this.$RequestUtil.getAsync({url: "/api/property-extend/list", type: "sync",params: {type:0}, });
            data.forEach(item=>{
                item.propertyValue = null
            })
            this.propertyExtendList = data
            // return data
        },
        showAllRow(ev) {
            if (ev) {
                this.tableData.forEach(row => {
                    this.expands.push(row.id)
                })
            } else {
                this.expands = []
            }
        },
        parseMrpType(rowData) {
            if (rowData.mrpType == 0) {
                return '自制生产'
            } else {
                return '外购'
            }
        },

        selectable(row, index) {
            return row.canMrp
        },

        getsubmitParams(spliteItemList,pass=true){
            
            spliteItemList.forEach(item=>{
                if(!item.materialQualityName){
                    pass = false
                }
                this.orderList = [...this.orderList,{
                     "businessOrderPropertyExtend": item.orderSplitPropertyExtendList,
                    "materialQualityName":item.materialQualityName,
                    "orderCode": item.orderCode,
                    "orderItemRow": item.orderItemRow,
                    "mrpType": item.mrpType,
                    "materialName": item.materialName,
                    "materialCode": item.materialCode,
                    "specification": item.specification,
                    "demandAmount": item.demandAmount,
                    "unitType": item.unitType,
                    "priority": item.priority,
                    "availableAmount": item.availableAmount,
                    "useStock": item.useStock,
                    "bomId": item.bomId,
                    "parentId": item.parentId,
                    "yieldRate": item.yieldRate,
                    "consumptionRate": item.consumptionRate,
                    "itemId": item.itemId,
                    "useAmount": item.useAmount,
                    "producingAmount": item.producingAmount?item.producingAmount:0,
                    "needStockAmount": item.needStockAmount?item.needStockAmount:0
                }]
                pass = this.getsubmitParams(item.next,pass)
            })
            return pass
        },

        submitSplitMaterial() {
            this.orderList = []
            let pass = this.getsubmitParams(this.spliteList)
            if(!pass){
              this.$message.error('材质不能为空')
              return
            }
            let dataList = [{ itemId:this.orderList[0].itemId,spliteItemList:this.orderList }]
            this.$RequestUtil.post({
                url: '/api/order/doMRP',
                params: { dataList },
                type: 'sync',
                success: res => {
                    if (res.code == 0) {
                        this.isShowDialog = false
                        this.search()
                        this.$store.commit('add_reloadPages', ["/ProductionTask"])
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            })

        },

        async splitOrderItem(orderIdList,itemId) {
            let data = await this.loadSplitMaterial(orderIdList,itemId)
            let arr = []
            this.orderList = data.map(item => {
                item.dataList.forEach(sub => {
                    sub.itemId = item.itemId
                })
                this.appendExtendP(item.dataList,item.dataList[0].orderSplitPropertyExtendList)
                arr = [...arr, ...item.dataList]
                return { itemId: item.itemId, len: item.dataList.length }
            })
            this.spliteList = arr
            
            log(arr)
            this.isShowDialog = true
            // demandAmount- 毛需求量     availableAmount -可用总库存量  producingAmount - 待生产数量  needStockAmount - 抵扣库存量
            this.spliteList[0].useAmount = this.spliteList[0].demandAmount
            // this.setBomMaterialCount(this.spliteList, 0)
            this.treeLoop(this.spliteList)
        },

        //制单添加扩展信息
        appendExtendP(dataList,defaultP){
            dataList.forEach(e=>{
                e.materialQualityNameDisable = false
                if(e.materialQualityName){
                    e.materialQualityNameDisable = true
                }
                e.orderSplitPropertyExtendList = this.propertyExtendList.map(item=>{
                    let p = defaultP.find(p=>p.propertyName == item.propertyName)
                    return {
                        propertyExtendId:item.id,
                        propertyName:item.propertyName,
                        propertyValue:p?p.propertyValue:''
                    }
                })
                this.appendExtendP(e.next,defaultP)
            })
        },

        itemInputChange(ev, now) {
            // let parent = this.findParent(this.spliteList,now)
            // log(parent,'parent')
            if(now.next){
                this.treeLoop(now.next,now)
            }
        },

        findParent(tree,data){
            let parent = null
            for(let i=0;i<tree.length;i++){
                let item = tree[i]
                if(item.bomId==data.parentId){
                    parent = item
                    break
                }
                if(item.next&&item.next.length>0){
                    this.findParent(item.next,data)
                }
            }
            return parent
        },

        treeLoop(data,parent){
            for(let i=0;i<data.length;i++){
                let item = data[i]
                if(item.next&&item.next.length>0){
                    if(!parent){
                        item.producingAmount = item.demandAmount
                    }else{
                        this.setProducingAmount(item,parent)
                    }
                    this.treeLoop(item.next,item)
                }else{
                    if(!parent){
                        item.producingAmount = item.demandAmount
                    }else{
                        this.setProducingAmount(item,parent)
                    }
                }
            }
        },

        setProducingAmount(now,parent){
            let producingAmount = (parent.producingAmount * now.priority / parent.priority)*100*100/(parent.yieldRate)/(100-now.consumptionRate)
            this.$set(now,'producingAmount',this.keepTwoDecimal(producingAmount))
        },

     
        
        keepTwoDecimal(n) {
            n = Number(n)
            return Math.round(n * 100) / 100
        },

        async loadSplitMaterial(orderIdList,itemId) {
            let { data, code, message, msg } = await this.$RequestUtil.postAsync({ url: '/api/order/listBomSplit', params: { orderIdList,itemId }, type: 'sync' })
            if (code == 0) {
                return data
            } else {
                this.$message.error(message || msg)
            }
        },

        selectSalesOrder() {
            if (this.$refs.refTable.selection.length < 1) {
                this.$message.warning('请先选择需要生产制单的订单')
                return
            }
            let orderIdList = this.$refs.refTable.selection.map(item => item.id)
            this.splitOrderItem(orderIdList)
        },
        prepareDocument(row){
             this.splitOrderItem([row.orderId],row.id)
        },

        async showPrepareDetail(row){
            let { data, code, message, msg } = await this.$RequestUtil.postAsync({ url: '/api/order/listBilledDetail', params: { itemId:row.id }, type: 'sync' })
            if (code != 0) {
                 this.$message.error(message || msg)
                 return
            }
               
            // let arr = []
            // data.map(item => {
            //     item.dataList.forEach(sub => {
            //         sub.itemId = item.itemId
            //     })
            //     this.appendExtendP(item.dataList,item.dataList[0].orderSplitPropertyExtendList)
            //     arr = [...arr, ...item.dataList]
            //     return { itemId: item.itemId, len: item.dataList.length }
            // })
            this.spliteList = data
            this.isShowDetail = true
        },
        expandChange(row) {
            let index = this.expands.indexOf(row.id)
            if (index > -1) {
                this.expands.splice(index, 1)
            } else {
                this.expands.push(row.id)
            }
        },
        setUrgentOrder(row) {
            this.$RequestUtil.get({
                url: '/api/order/setCancelUrgentOrder',
                params: {
                    orderId: row.id,
                    type: true
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.$message({ type: 'success', message: '设置成功!' });
                        this.search(this.pageNum);
                    }
                }
            });

        },
        cancelUrgentOrder(row) {
            this.$RequestUtil.get({
                url: '/api/order/setCancelUrgentOrder',
                params: {
                    orderId: row.id,
                    type: false
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.$message({ type: 'success', message: '取消成功!' });
                        this.search(this.pageNum);
                    }
                }
            });

        },
        rowClass({ row, columnIndex }) {
            if (row.isUrgent > 0) {
                return { "background-color": "#fff0f0" }
            }
        },
        async loadstatusOrderCount() {
            let { data } = await this
                .$RequestUtil
                .getAsync({
                    url: '/api/order/getAmountOfStates',
                    params: {
                        isWeb: true
                    }
                });
            this.statusCount0 = data['0']
            this.statusCount2 = data['2']
            this.statusCount4 = data['4']
            this.statusCount5 = data['5']
            this.statusCount99 = data['99']
            this.statusCount7 = data['7']
        },
        changeActive(num) {
            if (num == null) {
                this.activeItem = null
            } else {
                this.activeItem = Number(num)
            }
            if (num != 1) {
                this.searchForm.extraValue = null
            }
            if (num == 2) {
                this.searchForm.isPostpone = null
            } else if (this.checked == true && num != 2) {
                this.searchForm.isPostpone = null
            } else if (this.checked == false && num != 2) {
                this.searchForm.isPostpone = 0
            }
            this.page.currentPage = 1
            this.searchForm.orderStatus = this.activeItem
            this.searchCopy = commonUtils.cloneObj(this.searchForm)
            this.loadstatusOrderCount()
            this.search()

        },
        async remoteMethod5(query) {
            this.orderLoading = true;
            this.searchStr = query
            await this.orderRemoteMethod(query)
            this.orderLoading = false
        },
        async closeOrderList(ev) {
            if (!ev) {
                if (this.searchStr) {

                    if (!this.searchForm.orderId) {
                        this.$set(this.searchForm, 'orderId', this.searchStr)
                    } else {
                        let find = this.orderOptions.find(item => item.label.includes(this.searchForm.orderId))
                        if (!find) {
                            this.$set(this.searchForm, 'orderId', this.searchStr)
                        }
                    }
                }
            }else{
                this.remoteMethod5()
            }
        },
        async closeProductList(ev,type) {
            if (!ev) {
                let data = await this.loadMaterialList()
                if(type==0){
                    this.materialList1 = data
                }else{
                    this.materialList = data
                }
            }else{
                if(type==0){
                    this.remoteMethod4('','',0)
                }
            }
        },
        async remoteMethod4(materialCode,materialName,type) {
            this.productLoading = true;
            let data = await this.loadMaterialList(materialCode,materialName)
            if(type==0){
                this.materialList1 = data
            }else{
                this.materialList = data
            }
            this.productLoading = false
        },

        async loadMaterialList(materialCode,materialName){
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: "/api/select/listMaterial",params: {materialCode,materialName}});
            if(code==0){
                return data
            }
        },

        parseStyle(rowData) {
            if (rowData.isPostpone == true) {
                return "red"
            } else if (rowData.isPostpone == false) {
                return ''
            }
        },

        deliverClass(i) {
            return i
                ? 'deliverClassA'
                : 'deliverClassB'
        },

        codeSelectChange(val) {

            if (val === null || val === 0 || val === '') {
                this.searchForm.productionOrderCode = '';
            } else {
                let arr = this.productionCodeList;
                if (arr.length > 0) {
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i].value === val) {
                            this.searchForm.productionOrderCode = arr[i].label;
                            this.selectProductionId = val
                            break;
                        }
                    }
                }
            }
        },
        async loadProductionCode(query) {
            let { data } = await this
                .$RequestUtil
                .getAsync({
                    url: '/api/select/listProductionOrderCodeByOrder',
                    params: {
                        productionOrderCode: query
                    }
                });
            this.productionCodeList = data;
        },
        handlemyclass(row, column, rowIndex, columnIndex) {
            // log(row, column, rowIndex, columnIndex, 1111)
            if (row.columnIndex == 0) {

                return 'cellheader select-header'
            } else {
                return 'cellheader'
            }

        },
        orderStateChange(val) { },
        reload(pageNum, orderColumn, orderType) {
            if (orderColumn && orderType) {
                this.orderColumn = orderColumn
                this.orderType = orderType
                let order = ''
                if (orderType == 'DESC') {
                    order = 'descending'
                } else {
                    order = 'ascending'
                }
                this.defaultSort = {
                    prop: orderColumn,
                    order
                }
            }

            if (pageNum) {
                this.search(pageNum);
            } else {
                this.search(1);
            }
            this.loadstatusOrderCount()
            this.$forceUpdate()
        },
        orderSampleDownload() { },

        showOrderProductView(row) {
            row.parseState = this.parseOrderState(row)
            if(!row.moduleImageURLList){
                log(row,'666')
                row.moduleImageURLList = []
            }
            this.selectedOrder = row;
            this.selectedOrder.pageNum = this.pageNum
            this.selectedOrder.orderColumn = this.orderColumn
            this.selectedOrder.orderType = this.orderType

            this.showPage = 1;
        },

        showProgress(row, column, cellValue, index) {
            let all = row.partCount;
            let finished = row.processedCount;
            finished = finished == null
                ? 0
                : finished;
            return (100 * finished / all).toFixed(2) + '%';
        },
        orderSelectChange(val) {

        },
        async orderRemoteMethod(query) {
            let { data } = await this
                .$RequestUtil
                .getAsync({
                    url: '/api/select/listOrder',
                    params: {
                        orderCode: query
                    }
                });
            this.orderOptions = data.filter(item => item.label);
            // log(this.orderOptions)
        },
        deviceSelectChange(val) {
            if (val === null || val === 0 || val === '') {
                this.searchForm.deviceName = '';
            } else {
                let arr = this.deviceOptions;
                if (arr.length > 0) {
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i].value === val) {
                            this.searchForm.deviceName = arr[i].label;
                            break;
                        }
                    }
                }
            }
        },
        deviceRemoteMethod(query) {
            this.deviceLoading = true;
            setTimeout(() => {
                this
                    .$RequestUtil
                    .get({
                        url: '/api/select/listDevice',
                        params: {
                            deviceName: query
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.deviceOptions = res.data;
                                this.deviceLoading = false;
                            }
                        }
                    });
            }, 200);
        },
        workerSelectChange(val) {
            if (val === null || val === 0 || val === '') {
                this.searchForm.workerName = '';
            } else {
                let arr = this.workerOptions;
                if (arr.length > 0) {
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i].value === val) {
                            this.searchForm.workerName = arr[i].label;
                            break;
                        }
                    }
                }
            }
        },
        workerRemoteMethod(query) {
            this.workerLoading = true;
            setTimeout(() => {
                this
                    .$RequestUtil
                    .get({
                        url: '/api/select/listWorker',
                        params: {
                            workerName: query
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.workerOptions = res.data;
                                this.workerLoading = false;
                            }
                        }
                    });
            }, 200);
        },
        importOrder() {
            this.showImportOrderView = true;
        },

        addOrder() {
            this.showAddOrderView = true;
        },
        editOrder(rowData) {
            this.showEditOrderView = true
            this.isView = false;
            this.editForm = commonUtils.cloneObj(rowData)
        },
        showOrder(rowData){
            this.showEditOrderView = true
            this.isView = true;
            this.editForm = commonUtils.cloneObj(rowData)
        },
        pageChange(pageNum) {
            this.$set(this, 'searchForm', commonUtils.cloneObj(this.searchCopy));
            this.loadstatusOrderCount()
            this.search(pageNum);
        },
        //排序改变事件
        sortChangeEvent(param) {
            console.log(param);
            let orderType = param.order;
            let orderColumn = param.prop;
            this.orderColumn = orderColumn;
            if (orderType == 'descending') {
                this.orderType = 'DESC';
            } else if (orderType == 'ascending') {
                this.orderType = 'ASC';
            } else {
                this.orderType = orderType;
                this.orderColumn = null
            }

            if (this.comebackFlag) {
                this.comebackFlag = false;
                console.log('排序', this.oldPageNum)
                if (this.oldPageNum) {
                    this.page.currentPage = this.oldPageNum
                }
                this.search(this.page.currentPage);

            } else {
                this.search(1);
            }
            this.page.currentPage = 1
        },
        //列表查询
        search(pageNum) {
            if (pageNum == null || pageNum instanceof KeyboardEvent) {
                pageNum = 1;
            }
            this.pageNum = pageNum
            let form = this.searchForm;
            form.orderState = form.orderStatus
            let deliverStartTime = null
            let deliverEndTime = null
            if(form.deliverTime&&form.deliverTime.length==2){
                deliverStartTime = form.deliverTime[0]
                deliverEndTime=form.deliverTime[1]
            }
            let orderStartTime = null
            let orderEndTime = null
            if(form.orderTime&&form.orderTime.length==2){
                orderStartTime = form.orderTime[0]
                orderEndTime = form.orderTime[1]
            }

            let params = {
                orderState: form.orderState,
                orderCode: form.orderId,
                pageNum: pageNum,
                pageSize: this.page.pageSize,
                orderType: this.orderType,
                orderColumn: this.orderColumn,
                productionOrderCode: form.productionOrderCode,
                materialCode: form.materialCode,
                materialName: form.materialName,
                extraValue: form.extraValue,
                deliverStartTime,
                deliverEndTime,
                orderStartTime,
                orderEndTime,
                businessState: form.businessState
            };
            this.$RequestUtil.get({
                url: '/api/order/listBusinessOrder',
                type: 'sync',
                params: params,
                success: (res) => {
                    if (res.msg != "success") {
                        this
                            .$message
                            .error(res.message);
                        return;
                    }
                    let nowTime = new Date().getTime()
                    this.showOrderRow = false
                    this.showAllRow(false)
                    this.plannedRatio = res.data.plannedRatio

                    res.data.list.forEach(item => {
                        //判断订单是否延期
                        if (item.isPostpone) {
                            item.color = 'rgb(255,86,34)'
                        } else {
                            item.class = ''
                            if (item.processRatio == 0) {
                                item.color = 'rgb(244,246,245)'
                            } else if (item.processRatio > 0 && item.processRatio < 100) {
                                item.color = 'rgb(255,186,1)'
                            } else if (item.processRatio == 100) {
                                item.color = 'rgb(108,213,137)'
                            }
                        }
                        if (item.itemList) {
                            let optional = [];
                            item.itemList.forEach(sub => {
                                if (sub.optional) {
                                    sub.optional = JSON.parse(sub.optional)
                                    sub.optional.forEach(opt => {
                                        optional.push(opt);
                                    });
                                } else {
                                    sub.optional = []
                                }

                            })
                            item.optional = [...new Set(optional.map(o => o.attrName))]
                        }
                        item.orderTime = CommonUtils.timestampToDate(item.orderTime, true)
                        item.deliverTime = CommonUtils.timestampToDate(item.deliverTime, true)
                    })
                    this.tableData = res.data.list
                    log(this.tableData)
                    this.page.total = res.totalPages;
                    if (this.tableData.length > 0) {
                        this.page.isShow = true;
                    }
                    if (this.page.total == 0 && this.fristLoad) {
                        this
                            .$message
                            .warning('查询不到符合条件的数据');
                    }
                    this.fristLoad = true
                }
            });
        },
        rowDataIs($event) {
            // alert($event);
            if ($event == true) {
                this.isPostpone = null
                //代表已延期和没有延期所有数据
                this.page.currentPage = 1
                this.search();
            } else if ($event == false) {
                this.isPostpone = 0
                //代表返回没有延期的数据
                this.page.currentPage = 1
                this.search();
            }
        },
        //清空查询条件
        clearSearch() {
            let form = this.searchForm;
            form.orderId = '';
            form.orderCode = '';
            form.orderTime = []
            form.deliverTime = []
            form.orderStatus = '';
            form.isPostpone = '';
            form.productionOrderCode = null;
            form.materialName = ''
            form.materialCode = ''
            form.extraValue = null
            form.businessState = null;
            this.activeItem = null
        },
        clickSearch() {
            this.searchCopy = commonUtils.cloneObj(this.searchForm)
            this.page.currentPage = 1
            this.loadstatusOrderCount()
            this.search(1);
        },
        parseOrderState(rowData) {
            let find = this
                .options
                .find(item => item.value == rowData.businessState)
            if (find) {
                return find.label
            } else {
                return ''
            }
        },
        parseMaterialState(rowData){
            let find = this
                .materialStateOptions
                .find(item => item.value == rowData.itemState)
            if (find) {
                return find.label
            } else {
                return ''
            }
        },

        postPone(rowData) {
            if (rowData.isPostpone == true) {
                return '是'
            } else {
                return '否'
            }

            // if(this.checked==true){   return '是' }else
            // if(this.checked==false&&rowData.isPostpone==false){  this.tableData=''
            //
            // } let find = this.options.find(item => item.value == rowData.orderState) if
            // (find) {   return find.label } else {   return '' }
        },

        parseOrderDisassemblyRatio: function (rowData) {
            if (rowData.disassemblyRatio != null) {
                return rowData.disassemblyRatio + '%';
            }
        },
        parseOrderProcessRatio: function (rowData) {
            if (rowData.processRatio != null) {
                return rowData.processRatio + '%';
            }
        },

        deleteOrder: function (rowData) {
            this.$confirm('此操作将删除该订单, 相关拆分零件及任务都会被删除，是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/order/deleteOrderById',
                    type: 'sync',
                    params: {
                        id: rowData.id
                    },
                    success: (res) => {
                        if (res.code != -1) {
                            this.$message({ type: 'success', message: '删除成功!' });
                            this.search(this.pageNum);
                            this.orderRemoteMethod();
                            this.loadstatusOrderCount()
                            this.$store.commit('add_reloadPages', ["/Production"])
                        } else {
                            this.$message({ type: 'error', message: res.message });
                        }
                    }
                });
            });
        },
        cancelOrder: function (rowData) {
            this.$confirm('此操作将取消该订单, 是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/order/cancelOrder',
                    type: 'sync',
                    params: {
                        orderId: rowData.id
                    },
                    success: (res) => {
                        if (res.code != -1) {
                            this.$message({ type: 'success', message: '取消成功!' });
                            this.search(this.pageNum);
                            this.orderRemoteMethod();
                            this.loadstatusOrderCount()
                            this.$store.commit('add_reloadPages', ["/ProductionTask"])
                        } else {
                            this.$message({ type: 'error', message: res.message });
                        }
                    }
                });
            });
        },
        cancelMrp: function (rowData) {
            this.$confirm('此操作将取消生产制单, 相关拆分工单及任务都会被删除, 是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/order/unSplitOrderItem',
                    type: 'sync',
                    params: {
                        orderItemId: rowData.id
                    },
                    success: (res) => {
                        if (res.code != -1) {
                            this.$message({ type: 'success', message: '取消生产制单成功!' });
                            this.search(this.pageNum);
                            this.orderRemoteMethod();
                            this.loadstatusOrderCount()
                            this.$store.commit('add_reloadPages', ["/ProductionTask"])
                        } else {
                            this.$message({ type: 'error', message: res.message });
                        }
                    }
                });
            });
        },
        closeOrder(rowData) {
            this.$confirm("是否关闭该订单?", {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$RequestUtil.get({
                    url: "/api/order/closeOrder",
                    type: "sync",
                    params: {
                        orderId: rowData.id
                    },
                    success: res => {
                        if (res.code == 0) {
                            this.search(this.pageNum);
                            this.$store.commit('add_reloadPages', ["/ProductionTask"])
                            this.$message.success("关闭成功");
                        } else {
                            this.$message.error(res.msg || res.message);
                        }
                    }
                });
            });
        },
    },

    watch: {
        showPage: function (newVal, oldVal) {
            // 返回
            if (newVal == 0 && oldVal != 0) {
                this.comebackFlag = true;
            }
        },
        'activeStatus'(old, newNum) {
            log('监听到', old, newNum)
        },
        'orderPageChange'(old, newNum) {
            log('监听到', old, newNum)
        }
    },
    filters: {
        showAttrValue(arr, name) {
            if (!arr) {
                return "";
            } else {
                let find = false;
                let tmp = "";
                arr.forEach(item => {
                    if (item.attrName == name && item.attrValue) {
                        tmp = item.attrValue;
                    }
                });
                return tmp;
            }
        },
    }
}
</script>

<style scoped="scoped">
.help {
    background: url("/static/img/help.png");
    width: 17px;
    height: 17px;
    display: inline-block;
    background-size: cover;
    margin-left: 4px;
    position: relative;
    top: 4px;
}

.show-icon {
    width: 14px;
    height: 14px;
    display: inline-block;
    background-size: cover;
    margin-left: 0;
    position: relative;
    top: 3px;
}

.warp-box {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    /* margin-right: 80px; */
}

.status-item {
    flex: 1;
    height: 40px;
    background: rgb(245, 247, 252);
    margin-right: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}

.warp-item1 {
    background: url("/static/img/left.png");
    background-size: 100% 40px;
    z-index: 2;
}

.warp-item2 {
    background: url("/static/img/center.png");
    background-size: 100% 40px;
    z-index: 2;
}

.warp-item3 {
    background: url("/static/img/right.png");
    background-size: 100% 40px;
    margin-right: 0;
    z-index: 2;
}

.status-warp {
    position: relative;
    flex: 8;
    display: flex;
    margin-right: 80px;
}

.line {
    position: absolute;
    width: 100%;
    height: 6px;
    background: rgb(245, 247, 252);
    left: 0;
    top: 16px;
    z-index: 1;
}

.active-item {
    background: rgb(64, 158, 255);
    color: #ffffff;
}

.active-item1 {
    background: url("/static/img/left-active.png");
    color: #ffffff;
    background-size: 100% 40px;
    z-index: 2;
}

.active-item2 {
    background: url("/static/img/center-active.png");
    color: #ffffff;
    background-size: 100% 40px;
    z-index: 2;
}

.active-item3 {
    background: url("/static/img/right-active.png");
    color: #ffffff;
    background-size: 100% 40px;
    margin-right: 0;
    z-index: 2;
}

.planed-ratio {
    font-size: 14px;
}

/* @media screen and (min-width:1400px) and (max-width: 1800px) */
@media screen and (min-width: 1400px) and (max-width: 1700px) {
    .warp-box {
        margin-right: 40px;
        font-size: 12px;
    }

    .status-warp {
        margin-right: 40px;
    }

    .status-item {
        margin-right: 40px;
    }

    .warp-item3 {
        margin-right: 0;
    }
}

@media screen and (min-width: 1000px) and (max-width: 1399px) {
    .planed-ratio {
        font-size: 11px;
        position: relative;
        top: 2px;
    }

    .help {
        width: 14px;
        height: 14px;
    }

    .warp-box {
        margin-right: 0;
        font-size: 12px;
    }

    .status-warp {
        margin-right: 25px;
        flex: 6;
    }

    .status-item {
        margin-right: 25px;
        line-height: 40px;
        height: 40px;
    }

    .warp-item1 {
        background-size: 100% 40px;
    }

    .warp-item3 {
        background-size: 100% 40px;
    }

    .warp-item2 {
        background-size: 100% 40px;
    }

    .active-item1 {
        background-size: 100% 40px;
    }

    .active-item2 {
        background-size: 100% 40px;
    }

    .active-item3 {
        background-size: 100% 40px;
    }

    .line {
        top: 17px;
    }

    .warp-item3 {
        margin-right: 0;
    }

}

.operateBtn-wrap {
    margin-top: 10px;
    margin-bottom: 0px;
}

.search-input-row {
    margin-top: 10px;
}

.search-input-wrap {
    margin-bottom: 20px;
}

.page {
    display: flex;
    justify-content: flex-end;
}

.total_page {

    margin-right: 20px;
    color: #606266;
    font-size: 14px;
    line-height: 50px;
}

@media screen and (max-width: 1380px) {
    #orderMgt {
        height: auto;
        margin-bottom: 30px;
    }

    .page {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;
    }
}

.table_searchbar .title11 {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    width: 70px;
    display: inline-block;
    text-align: right;
}

.exprot_info {
    text-align: center;
}
</style>

<style>

    .width180 {
        width: 180px;
    }

    .el-button--mini.is-round,
    .table_searchbar .el-button--mini {
        padding: 7px 10px;
    }

    .cellheader .cell {
        /* height: 36px; */
        line-height: 36px;
    }
    .select-header .cell {
        margin-left: 4px;
    }

    .bar-bg .el-progress-bar__outer {
        background: rgb(255, 86, 34);
    }
    .deliverClassA {
        max-width: 110px;
        text-align: center;
        padding: 8px 0;
        background: #e84e0f;
        color: #ffffff;
    }
    .deliverClassB {
        max-width: 110px;
        text-align: center;
    }
    .table-in-table td,
    .table-in-table th.is-leaf {
        border-bottom: none;
    }
    .table-in-table .el-table--border::after,
    .table-in-table .el-table--group::after,
    .table-in-table::before {
        content: "";
        position: absolute;
        /* background-color: #ffffff; */
        z-index: 1;
    }

    .table-in-table thead {
        color: #333;
    }

    #sales-order .table-in-table thead th,
    #sales-order .table-in-table tbody td {
        background-color: #f0f0fa !important;
    }
     #sales-order .table-in-table thead tr,
    #sales-order .table-in-table tbody tr{
        margin-left: 0;
    }
    #sales-order .table-in-table .el-table--border td, #sales-order .table-in-table .el-table--border th, #sales-order .table-in-table .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #fff;
    }
    #sales-order .table-in-table .el-card__body{
        padding: 0px;
    }

</style>



// WEBPACK FOOTER //
// src/views/order/SalesOrder/index.vue